import { AlertOutlined } from '@ant-design/icons';
import styled from 'styled-components';
export const AlertIcon = styled(AlertOutlined)`
  margin-right: 0px !important;
`;